import { getToken, getUser } from "../../Utils/Common"
import { getAPICall, postAPICall } from "../axiosMethodCalls"
import Moment from "moment"

export const getSalesInvoice = async (info) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "sales_invoices/get",
      {
        requester: getUser(),
        token: getToken(),
        sales_invoice_id: info.id,
        customer_id: info.customer_id,
        customer_name: info.customer_name,
        status: info.status === "all" ? "" : info.status,
        anything: info.anything,
        with_invoice: info.with_invoice,
        date_from: info.date_from
          ? Moment(info.date_from).format("YYYY-MM-DD")
          : info.date_from,
        date_to: info.date_to
          ? Moment(info.date_to).format("YYYY-MM-DD")
          : info.date_to,
        page: info.page,
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

//POST
export const createSalesInvoice = async (data, items) => {
  let form_data = new FormData()
  data.attachments.map((file) => {
    form_data.append(`attachments[]`, file, file.name)
  })
  form_data.append("requester", getUser())
  form_data.append("token", getToken())
  form_data.append("sales_order_id", data.id)
  if (data.invoice_no) {
    form_data.append("invoice_no", data.invoice_no ? data.invoice_no : "")
  }
  form_data.append("customer_id", data.customer_id)
  form_data.append("forwarder_id", data.forwarder_id ? data.forwarder_id : "")
  form_data.append("release_from", data.release_from)
  form_data.append("release_by", data.release_by)
  form_data.append("branch_id", data.branch_id)
  form_data.append(
    "transfer_slip_no",
    data.transfer_slip_no ? data.transfer_slip_no : ""
  )
  form_data.append("sales_date", data.sales_date)
  form_data.append("delivery_date", data.delivery_date)
  form_data.append("delivery_fee", data.delivery_fee ? data.delivery_fee : 0)
  form_data.append("service_fee", data.service_fee)
  form_data.append("ship_via", data.ship_via)
  form_data.append("contact_no", data.contact_no)
  form_data.append("address", data.address)
  form_data.append("remarks", data.remarks || "")
  form_data.append(
    "discount_total",
    data.discount_total ? data.discount_total : 0
  )
  form_data.append("grand_total", data.grand_total)
  form_data.append("subtotal", data.subtotal)
  form_data.append("paid_total", 0)
  form_data.append("balance", data.balance)
  // form_data.append("status", data.status);
  form_data.append("customer_po_no", data.customer_po_no || "")
  form_data.append("withholding_percentage", data.withholding_percentage)
  form_data.append("vat_type", data.vat_type)
  form_data.append("discount", data.discount ? data.discount : 0)
  form_data.append("discounted_subtotal", data.discounted_subtotal)
  form_data.append("vat", data.vat)
  form_data.append("vatable_sales", data.vatable_sales)
  form_data.append("withholding_tax", data.withholding_tax)
  form_data.append(
    "grandtotal_without_service_fee",
    data.grandtotal_without_service_fee
  )

  items.map((item) => {
    // form_data.append(`sales_order_item_id[]`, item.id ? item.id : null)
    item.id && form_data.append(`sales_order_item_id[]`, item.id)
    form_data.append(`item_id[]`, item.item_id)
    form_data.append(`item_name[]`, item.item_name)
    form_data.append(`item_unit_id[]`, item.item_unit_id)
    form_data.append(`unit[]`, item.unit)
    form_data.append(`description[]`, item.description ? item.description : "")
    form_data.append(`price[]`, item.price)
    form_data.append(`qty[]`, item.qty)
    form_data.append(`qty_received[]`, item.qty_received)
    form_data.append(`discount_percentage[]`, item.discount_percentage || "0")
    form_data.append(`discount_amount[]`, item.discount_amount || "0")
    form_data.append(`subamount[]`, item.subtotal)
    form_data.append(`amount[]`, item.amount)
    form_data.append(
      `item_remarks[]`,
      item.item_remarks ? item.item_remarks : ""
    )
  })
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "sales_invoices/create",
      form_data
    )
    return { data: response.data }
  } catch (error) {
    return { error: error }
  }
}

export const updateSalesInvoice = async (data, items) => {
  let form_data = new FormData()
  data.attachments.map((file) => {
    form_data.append("attachments[]", file, file.name)
    form_data.append("attachment_ids[]", null)
  })
  data.prev_files.map((file) => {
    form_data.append("attachment_ids[]", file.id)
  })
  form_data.append("requester", getUser())
  form_data.append("token", getToken())
  form_data.append("sales_invoice_id", data.id)
  form_data.append("invoice_no", data.invoice_no ? data.invoice_no : "")
  form_data.append("sales_order_id", data.sales_order_id)
  form_data.append("customer_id", data.customer_id)
  form_data.append("forwarder_id", data.forwarder_id ? data.forwarder_id : "")
  form_data.append("branch_id", data.branch_id)
  form_data.append("release_from", data.release_from)
  form_data.append("release_by", data.release_by)
  form_data.append(
    "transfer_slip_no",
    data.transfer_slip_no ? data.transfer_slip_no : ""
  )
  form_data.append("sales_date", data.sales_date)
  form_data.append("delivery_date", data.delivery_date)
  form_data.append("delivery_fee", data.delivery_fee ? data.delivery_fee : 0)
  form_data.append("service_fee", data.service_fee)
  form_data.append("ship_via", data.ship_via)
  form_data.append("contact_no", data.contact_no)
  form_data.append("address", data.address)
  form_data.append("remarks", data.remarks || "")
  form_data.append("discount_total", data.discount ? data.discount : 0)
  form_data.append("grand_total", data.grand_total)
  form_data.append("subtotal", data.subtotal)
  form_data.append("paid_total", 0)
  form_data.append("customer_po_no", data.customer_po_no)
  form_data.append("balance", data.balance)
  // form_data.append("status", data.status);

  form_data.append("withholding_percentage", data.withholding_percentage)
  form_data.append("vat_type", data.vat_type)
  form_data.append("discount", data.discount ? data.discount : 0)
  form_data.append("discounted_subtotal", data.discounted_subtotal)
  form_data.append("vat", data.vat)
  form_data.append("vatable_sales", data.vatable_sales)
  form_data.append("withholding_tax", data.withholding_tax)
  form_data.append(
    "grandtotal_without_service_fee",
    data.grandtotal_without_service_fee
  )

  items.map((item) => {
    form_data.append(`sales_invoice_item_id[]`, item.id ? item.id : null)
    // item.sales_order_item_id && form_data.append(`sales_order_item_id[]`,item.sales_order_item_id);
    form_data.append(`item_id[]`, item.item_id)
    form_data.append(`item_name[]`, item.item_name)
    form_data.append(`item_unit_id[]`, item.item_unit_id)
    form_data.append(`unit[]`, item.unit)
    form_data.append(`description[]`, item.description ? item.description : "")
    form_data.append(`price[]`, item.price)
    form_data.append(`qty[]`, item.qty)
    form_data.append(
      `qty_received[]`,
      item.qty_received ? item.qty_received : 0
    )
    form_data.append(`discount_percentage[]`, item.discount_percentage || "0")
    form_data.append(`discount_amount[]`, item.discount_amount || "0")
    form_data.append(`subamount[]`, item.subtotal)
    form_data.append(`amount[]`, item.amount)
    form_data.append(
      `item_remarks[]`,
      item.item_remarks ? item.item_remarks : ""
    )
  })
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "sales_invoices/update",
      form_data
    )
    return { data: response.data }
  } catch (error) {
    return { error: error }
  }
}

export const deleteSalesInvoice = async (id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "sales_invoices/delete",
      {
        requester: getUser(),
        token: getToken(),
        sales_invoice_id: id,
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error }
  }
}

export const emailSalesInvoice = async (id, file) => {
  const formData = new FormData()
  formData.append("requester", getUser())
  formData.append("token", getToken())
  formData.append("id", id)
  formData.append("attachment", file)

  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "emails/send_sales_invoice",
      formData
    )
    return { response: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

export const createBir2037SalesInvoice = async (id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "Birform/sales_invoice_generate2307",
      {
        requester: getUser(),
        token: getToken(),
        sales_invoice_id: id,
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error }
  }
}
